import { Navigate } from 'react-router-dom';
import { auth } from '../services';
import { getHomePathForRole, normalizeRole } from '../utils/roles';

/**
 * InstructorRoute - Allows access for users with role Instructor or Admin.
 */
const InstructorRoute = ({ children }) => {
  if (!auth.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const user = auth.getUser();
  if (!user) {
    auth.clearAuth();
    return <Navigate to="/login" replace />;
  }

  const role = normalizeRole(user.role);
  if (role !== 'instructor' && role !== 'admin') {
    return <Navigate to={getHomePathForRole(role)} replace />;
  }

  return children;
};

export default InstructorRoute;
